import ProductPageTemplate from "@/components/automacao/ProductPageTemplate";

const Erp = () => <ProductPageTemplate slug="erp" />;

export default Erp;
